import styled from 'styled-components';
export var Container = styled.form.withConfig({
  displayName: "elements__Container",
  componentId: "sc-19h58b9-0"
})(["width:100%;height:auto;display:flex;flex-direction:column;"]);